export const MAX_RATING = 5

export const RATING_TEXT_ID = 'star-rating-text-content'
export const SELLER_MODAL_POSTFIX = '-seller-modal'
